import { useStore } from "@/store";
import {
  CheckCircleIcon,
  ClockIcon,
  XCircleIcon,
} from "@heroicons/vue/24/outline";
import SpinnerVue from "./components/utils/Spinner.vue";
import SpinnerIcon from "./components/utils/SpinnerIcon.vue";
import { shallowRef } from "vue";
import _ from "lodash";
import { DefaultService as api } from "@/client";

export function getFieldsFromPromptVersion(promptVersion) {
  if (!promptVersion?.prompt_template?.chat) return [];
  // across all chat messages
  let fieldsWithBrackets = promptVersion.prompt_template.chat
    .map((message) => {
      return message.content.match(/{{(.*?)}}/g);
    })
    .flat()
    .filter((field) => field !== null);
  //   console.log(fieldsWithBrackets);
  //   let fieldsWithBrackets = prompt.value.match(/{{(.*?)}}/g);
  let fields = [];
  if (fieldsWithBrackets) {
    fields = fieldsWithBrackets.map((field) => {
      return field.replace("{{", "").replace("}}", "").trim();
    });
  }
  return fields;
}

export function getFieldsStatus(fields, promptVersion) {
  let fieldsInPrompt = getFieldsFromPromptVersion(promptVersion);

  // let unusedFields = fields
  //   ? fields.filter((field) => {
  //       return _.isEmpty(fieldsInPrompt) && !fieldsInPrompt.includes(field);
  //     })
  //   : [];

  let missingFields =
    fieldsInPrompt?.filter((field) => {
      return _.isUndefined(fields) || !fields.includes(field);
    }) || [];

  return {
    unusedFields: [],
    missingFields: missingFields,
  };
}

export function notifyPositive(title, message?) {
  const store = useStore();
  store.addNotification({
    title: title,
    message: message,
    sentiment: "positive",
  });
}

export function notifyNegative(title, message?) {
  const store = useStore();
  store.addNotification({
    title: title,
    message: message,
    sentiment: "negative",
  });
}
export function notifyInfo(title, message?) {
  const store = useStore();
  store.addNotification({
    title: title,
    message: message,
    sentiment: "neutral",
  });
}

export function round(n) {
  if (!n) return n;
  return Math.round(n * 1000) / 1000;
}

export function copyToClipboard(text: string) {
  navigator.clipboard
    .writeText(text)
    .then(() => notifyPositive("Copied to clipboard"));
}

export function statusToTableEntry(status: string, asShallowRef = true) {
  if (status == "success") {
    return {
      displayAs: "tag",
      icon: CheckCircleIcon,
      color: "green-500",
      value: status,
    };
  } else if (status == "running") {
    return {
      displayAs: "tag",
      icon: asShallowRef ? shallowRef(SpinnerIcon) : SpinnerIcon,
      value: status,
    };
  } else if (status == "cancelled") {
    return {
      displayAs: "tag",
      icon: XCircleIcon,
      color: "gray-300",
      value: status,
    };
  } else {
    return {
      displayAs: "tag",
      icon: XCircleIcon,
      color: "red-500",
      value: status,
    };
  }
}

export function openDocs(topic: string) {
  const store = useStore();
  if (topic == "main") {
    window.open("https://docs.ivycheck.com/", "_blank");
  } else {
    store.displayDocs(topic);
  }
}

export const defaultRubrics = [
  {
    name: "Accuracy",
    active: true,
    description: "Is the information in the response correct and reliable?",
  },
  {
    name: "Helpfulness",
    active: false,
    description:
      "Does the AI response provide the information or task completion assistance requested by the user?",
  },
];

export function setDefaultLlm(config) {
  const store = useStore();
  if (_.isUndefined(config.model_provider) && store.modelProviders.length > 0) {
    config.model_provider = store.modelProviders[0];
    config.model = store.models[store.modelProviders[0]][0];
  }

  if (_.isUndefined(config.temperature)) config.temperature = 1.0;
  if (_.isUndefined(config.max_length)) config.max_length = 1024;

  return config;
}

export function processConfig(config) {
  if (_.isEmpty(config?.rubrics)) config.rubrics = defaultRubrics;
  setDefaultLlm(config);

  return config;
}
